import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Header from "../../components/Common/Header/Header";
import Footer from '../../components/Common/Footer/Footer';
import IntroSectionCyberAudit from '../../components/CyberAudit/IntroSectionAuditCyber/IntroSectionCyberAudit';
import ServicesCardsPrivateCloud from '../../components/PrivateCloud/ServicesCardsPrivateCloud/ServicesCardsPrivateCloud';
import PricingPrivateCloud from '../../components/PrivateCloud/PricingPrivateCloud/PricingPrivateCloud';
import Navbar from "../../components/Common/Navbar/Navbar";
import Newsletter from '../../components/Common/Newsletter/Newsletter';
import ServiceList from '../../components/CyberAudit/ServicesSliderCyberData/ServicesSliderCyberData';
import ParallaxComponent from '../../components/Common/ParallaxBackground/ParallaxComponent';
import auditCyberParallaxText from '../../components/Common/ParallaxBackground/auditCyberParallaxText';
import ParallaxIMG0 from './../../assets/images/itmonkeys-cyber-img-p0.png';
import ParallaxIMG1 from './../../assets/images/itmonkeys-cyber-img-p1.png';
import ParallaxIMG2 from './../../assets/images/itmonkeys-cyber-img-p2.png';
import ExpertiseSection from '../../components/CyberAudit/ExpertiseSectionCyberAudit/ExpertiseSectionCyberAudit';
import IntroSectionBottom from '../../components/Common/IntroSectionBottom/IntroSectionBottom';
import introSectionData7 from '../../components/Common/IntroSectionBottom/introSectionData7';
import useSectionRefs from '../../hooks/useSectionRefs';
import ServicesDataBenefits from '../../components/CyberAudit/ServicesSliderCyberData/BenefitsPrivateCloud';
import { contactLinkData } from '../../data/contactLinkData';
import ContactLinkSection from '../../components/Common/ContactLinkSection/ContactLinkSection';
import Timeline from '../../components/CyberAudit/Timeline/TimelinePrivateCloud';
import { GridPatternCard, GridPatternCardBody } from '../../components/ui/card-with-ellipsis-pattern';

const VatpCyber: React.FC = () => {
    const { t } = useTranslation();
    const sectionRefs = useSectionRefs();

    const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  
    const handleOpenContactModal = () => {
      setIsContactModalOpen(true);
    };
  
    const handleCloseContactModal = () => {
      setIsContactModalOpen(false);
    };

  return (
    <div>
      <div>
      <section id="header" className="section dark" ref={sectionRefs.header}>
        <div>
          <Navbar 
            sectionRefs={sectionRefs}
            openContactModal={handleOpenContactModal}
            closeContactModal={handleCloseContactModal}
          />
          <Header title={t('auditCyber.header.title', 'Audit de cybersécurité')} subtitle={t('auditCyber.header.subtitle', 'Identifiez vos failles de sécurité avant qu\'il ne soit trop tard')} />
        </div>
      </section>
      <section id="start" className="section light" ref={sectionRefs.start}>
        <IntroSectionCyberAudit />
        <IntroSectionBottom data={introSectionData7} translationNamespace="auditCyber" />
      </section>
        <div className="gradient-bg">
      <section id="start2" className="section dark" ref={sectionRefs.start2}>
      <ParallaxComponent
        images={{
          layer1: ParallaxIMG0,
          layer2: ParallaxIMG1,
          layer3: ParallaxIMG2,
        }}
        textContent={auditCyberParallaxText}
        contentBelowParallax={""}
        wrapperClassName="parallax__wrapper_cyberaudit"
        translationNamespace="auditCyber"
        />
          </section>
          <div className="gradient-bg">
            <section
              id="expertise"
              className="section dark"
              ref={sectionRefs.expertise}
            >
          <Timeline />
          <GridPatternCard>
            <GridPatternCardBody>
              <div className="tw-h-[5em]">
              </div>
            </GridPatternCardBody>
          </GridPatternCard>
            </section>
          </div>
        </div>
      <section id="newsletter" className="section dark" ref={sectionRefs.newsletter}>
      <ContactLinkSection pageKey="auditCyber" />
      <Footer />
      </section>
    </div>
    </div>
  );
};

export default VatpCyber;
